import { useEffect, useState } from "react";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export const TranslateInput = (text, fromLang, toLang) => {
  const [translatedText, setTranslatedText] = useState("");

  useEffect(() => {
    // If target is English or empty, reset translatedText to original text
    if (toLang === "en" || toLang === "") {
      setTranslatedText(text);
      return; // exit early, no API call needed
    }

    // Otherwise, call the translation API
    let url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`;
    url += "&q=" + encodeURI(text);
    url += `&source=${fromLang}`;
    url += `&target=${toLang}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        setTranslatedText(response.data.translations[0].translatedText);
      })
      .catch((error) => {
        console.log("There was an error with the translation request: ", error);
      });
  }, [text, fromLang, toLang]);

  return translatedText;
};

export const DetectLanguage = (text) => {
  const [detectedLang, setDetectedLang] = useState("");
  let url = `https://translation.googleapis.com/language/translate/v2/detect?key=${API_KEY}`;
  url += "&q=" + encodeURI(text);

  useEffect(() => {
    if (text !== "") {
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((response) => {
          setDetectedLang(response.data.detections[0][0].language);
        })
        .catch((error) => {
          console.log(
            "There was an error with the translation request: ",
            error
          );
        });
    }
  }, [url, text]);

  return detectedLang;
};
